<template>
  <div ref="header">
    <div v-for="ticket_item in ticket_info.in_chat_tickets"  :key="ticket_item.ticket_item_id"> 
       <!-- <pre>{{ticket_item}}</pre> -->
     <div class="ticket_info" v-if="ticket_item.ticket_item_id == ticket_info.current_ticket_id" >
      
     <!-- <div class="ticket_info" v-if="ticket_item.ticket_item_id == '195809'" > -->
       
        <div class="card-content">
            <div class="card-image">
                <img class="lazy" :src="'//spa.i99.to/product/' + ticket_item.product_id + '/350x219' + ticket_item.pic_url " alt="">
            </div>
            <div class="content_text" >
                <p class="title_text">{{ticket_item.ticket_project_name}}</p>
                <p class="sub_text">票號 {{ticket_item.ticket_no}}</p>
                <p class="sub_text" v-if="handle_applying_time(ticket_item) & (ticket_item.ticket_reserve_status == '已劃位' | ticket_item.ticket_reserve_status == '申請中') ">
                      體驗時間
                      {{
                          (ticket_item.applying_time? ticket_item.applying_time : ticket_item.reserving_time).substring(0,16).replace(/-/g,'/')
                      }}
                </p>

                <p class="sub_text f-pink">票券狀態 {{ticket_item.ticket_reserve_status}}</p>
            </div>
        </div>
        
        
        <div class ="seat rate_btn" v-if="ticket_item.apply_from_type == 0 & ticket_item.ticket_reserve_status=='申請中'">
            <div>
                <!-- <div class="f-gray_2 text_style" @click="set_ticket_option(ticket_item,'reject'); post_ticket_option(ticket_item);">拒絕</div> -->
                <!-- <div class="f-pink text_style"  @click="set_ticket_option(ticket_item); post_ticket_option(ticket_item);">接受</div> -->
                
                <div class="f-gray_2 text_style" @click="set_ticket_option(ticket_item,'reject'); post_ticket_option(ticket_item);">拒絕</div>
                <div class="f-pink text_style"  @click="set_ticket_option(ticket_item);post_ticket_option(ticket_item);">接受</div>
            </div>
        </div>
          
        <div class ="seat active_option" v-else-if="ticket_item.ticket_reserve_status=='未劃位'">
            <div>
                <div class="f-pink text_style"  @click="active_invitation_view(ticket_item)">提出劃位邀請</div>
            </div>
        </div>

        <div class ="seat active_option" v-else-if="ticket_item.apply_from_type == 1 & ticket_item.ticket_reserve_status=='申請中'">
            <div>
                <div class="f-pink text_style"  @click="set_ticket_option(ticket_item,'reject'); post_ticket_option(ticket_item);">取消邀請</div>
            </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: '',
  components:{
    
  },
  props: [
    'ticket_info'
  ],
  data: function () {
    return {
      // talk_info:{},//對話列表
    //   modalShowAdd:false,
      applying_time_flag:true
    }
  },
  computed: {
  },
  created() {
  },
  mounted () {
    this.init();
  },
  methods: {
    init:function(){
      
    },
    set_ticket_option:function(ticket_item,action_type){
       this.$parent.$emit('set_ticket_option',ticket_item,action_type) 
    },
    post_ticket_option:function(ticket_item){
      this.$parent.$emit('post_ticket_option',ticket_item) 
    },
    handle_applying_time:function(item){
      if(new Date(item.applying_time) < new Date()){
        item.ticket_reserve_status = '申請時段已過期';
        return false
      }
      this.$nextTick(function () {
        this.$parent.$emit('handler_msg_block_height')
      });
      return true
    },
    active_invitation_view:function(item,option){
      if(!option){
        this.$bus.invitation_ticket = item;
        this.$parent.$parent.$emit('chang_view',{
          view:'Appointment'
        });
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .chatroom_container{
    .ticket_info{
        margin: 0 auto;
        border-radius: .8rem;
        background-color: white;
        padding: 10px;
        position: relative;
        width: 100%;
        z-index: 1;
        box-shadow:4px 5px 4px -2px #cac8c8;
        .sub_text{
            font-weight: 400;
            font-size: 14px;
            margin-top: 3px;
        }
    }
    .content_text{
      text-align: left;
      font-size: 18px;
      color: #555;
      margin-left:5px;
      .title_text{
        text-align: left;
      }
    }
    .sub_text{
      margin-top:unset;
    }
    .ticket_info .rate_btn div span,
    .talk_block_container .rate_btn div span{
        padding-bottom: 0px;
    }
    .rate_btn{
      div div:first-child{
        border-right:solid 1px #eeeeee;
      }
      div{
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
      }
    }
   
  }
  
</style>
